import { useTranslation } from "react-i18next";
import { formatDate } from "../../utils/format";

const ServiceDate = ({ item }) => {
  // Read so the month re-renders in a new language
  useTranslation();

  return (
    <div className="service-date">
      <span className="service-date__month">{getMonthName(item.date)} </span>
      <span className="service-date__day">{getDayNumber(item.date)}</span>
    </div>
  );
};

// "NOV", "DIC" — the app language's short month, without the period Spanish ends it with
function getMonthName(date) {
  return formatDate(date, { month: "short" }).replace(".", "").toUpperCase();
}

function getDayNumber(date) {
  const d = new Date(date);
  return d.getDate();
}

export default ServiceDate;
